import { useState, useEffect } from "react";
import { Row, Container, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import bannerLogo from '../assets/img/bannerLogo.png';

export const Banner = () => {
    //const toRotate = ["Developer Backend", "Fabrication Engineer", "Industrial Designer"];

    const [toRotate, setToRotate] = useState(['']);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 1201) {
                setToRotate(["Developer", "Engineer", "Designer"]);
            } else {
                setToRotate(["Product Owner", "Frontend Developer", "Product Designer"]);
            }
        };

        window.addEventListener("resize", handleResize);
        handleResize(); // Call initially to set the initial value

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const period = 500;
    const initialDelta = 100;

    const [loopNumber, setLoopNumber] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(initialDelta);
    // eslint-disable-next-line no-unused-vars
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const ticker = setInterval(tick, delta);
        return () => clearInterval(ticker);
    }, [text, delta]);

    const tick = () => {
        const i = loopNumber % toRotate.length;
        const fullText = toRotate[i];
        const updatedText = isDeleting
            ? fullText.substring(0, text.length - 1)
            : fullText.substring(0, text.length + 1);

        setText(updatedText);

        if (isDeleting) {
            setDelta(initialDelta);
        }
        if (!isDeleting && updatedText === fullText) {
            setIsDeleting(true);
            setIndex(prevIndex => prevIndex - 1);
            setDelta(period);
        } else if (isDeleting && updatedText === '') {
            setIsDeleting(false);
            setLoopNumber(loopNumber + 1);
            setIndex(1);
            setDelta(initialDelta);
        } else {
            setIndex(prevIndex => prevIndex + 1);
        }
    };

    function scrollToConnect() {
        const connectSection = document.getElementById('connect');

        if (connectSection) {
            connectSection.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return (
        <section className="banner" id="home">
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} md={6} xl={7}>
                        <span className="tagline">Building Products that Matter</span>
                        <h1>
                            <span className="wrap">{text}</span>
                        </h1>
                        <p>
                            Industrial Design and Manufacturing Engineer, with expertise in digital product management, frontend development, and crafting user-centered digital experiences.
                        </p>
                        <button onClick={scrollToConnect}> Get in Touch! <ArrowRightCircle size={40} /></button>
                    </Col>

                    <Col xs={12} md={6} xl={5} className="d-none d-md-block"> {/* to hide */}
                        <img src={bannerLogo} alt="headerImage" />
                    </Col>
                </Row>
            </Container>
        </section>
    );
};